import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { Employee } from '../employee/employee';
import { EboObjectTimeLine } from './ebo-object-time-line';

export class EboObjectTimeLineSd extends EboObjectTimeLine {
  modifiedOn: Dayjs;
  modifiedById: string;
  modifiedBy?: Employee;
  modifiedViaId: string;
  deletedOn?: Dayjs;

  constructor(jsonData?: Partial<EboObjectTimeLineSd>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.modifiedOn) this.modifiedOn = SDate.newUtc(jsonData.modifiedOn);
      if (jsonData.deletedOn) this.modifiedOn = SDate.newUtc(jsonData.deletedOn);
    }
  }
}
